<script setup>
import {useUsersStore} from '@/stores'
const usersStore = useUsersStore()
let myUser = null
let isShowingLoadingOverlay = null;
({ myUser, isShowingLoadingOverlay } = storeToRefs(usersStore))


const showOverlay = ref(!navigator.onLine) // Initial state

const updateOnlineStatus = () => {
  console.log("updateOnlineStatus", navigator.onLine)
  showOverlay.value = !navigator.onLine
}

onMounted(() => {
  window.addEventListener('online', updateOnlineStatus)
  window.addEventListener('offline', updateOnlineStatus)
})

onBeforeUnmount(() => {
  window.removeEventListener('online', updateOnlineStatus)
  window.removeEventListener('offline', updateOnlineStatus)
})
</script>

<template>
  <VOverlay
    v-model="showOverlay"
    class="loader-overlay"
    persistent
  >
    <div class="loader-overlay-content text-center">
      <VIcon
        class=""
        icon="ion-cloud-offline-outline"
        size="40"
      />
      <div class="loader-overlay-content-text">
        No Internet Connection
      </div>
    </div>
  </VOverlay>
</template>


<style lang="scss" scoped>
.loader-overlay{
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-overlay-content {
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface-card);
  padding: 2.4rem 2rem 2.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1), 0px 29px 52px rgba(0, 0, 0, 0.1);
}

.loader-overlay-content-text {
  color: var(--ds-text-strong);
  margin-top: 1rem;
}
</style>
